/* src/app/shared/components/add-new-company-dialog/autocomplete.helper.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
::ng-deep .autocomplete-wrapper {
  border-radius: 8px;
  width: 100%;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
}
::ng-deep .autocomplete-results {
  font-family:
    "Inter",
    Arial,
    sans-serif,
    sans-serif !important;
  background: white;
  width: 100%;
  font-family: "Roboto", sans-serif;
  max-height: 400px;
  overflow-y: auto;
  border-bottom: 1px solid #E7ECF1;
}
::ng-deep .manual-entry {
  padding: 4px 24px 4px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::ng-deep .manual-entry button mat-icon {
  width: 24px !important;
  height: 24px !important;
  font-size: 22px !important;
}
::ng-deep .manual-entry button {
  background: transparent !important;
  color: #006BB6 !important;
}
::ng-deep .manual-entry button:disabled {
  color: red;
  opacity: 0.5;
  background: transparent !important;
  color: #006BB6 !important;
}
::ng-deep .manual-entry span {
  font-weight: 600;
}
@media (max-height: 1200px) {
  .autocomplete-results {
    max-height: 30vh;
  }
}
@media (max-height: 900px) {
  .autocomplete-results {
    max-height: 20vh;
  }
}
@media (max-height: 700px) {
  .autocomplete-results {
    max-height: 15vh;
  }
}
@media (max-height: 400px) {
  .autocomplete-results {
    max-height: 10vh;
  }
}

/* src/app/shared/components/add-new-company-dialog/add-new-company-autocomplete/add-new-company-autocomplete.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host {
  display: block;
}
::ng-deep .company-row {
  display: grid;
  grid-template-columns: 3fr 3fr 90px 90px;
  align-items: center;
  padding: 10px 12px;
}
::ng-deep .company-row:first-of-type {
  padding-top: 12px;
}
::ng-deep .company-row > div {
  display: flex;
  height: 100%;
}
::ng-deep .company-row > div mat-icon {
  margin-right: 4px;
}
::ng-deep .company-row > div small {
  font-size: 12px;
  opacity: 0.6;
}
::ng-deep .company-row .deals,
::ng-deep .company-row .contacts {
  justify-content: center;
}
::ng-deep .company-row .deals_flex-wrapper,
::ng-deep .company-row .contacts_flex-wrapper {
  flex-grow: 1;
}
::ng-deep .autocomplete-results .company-row {
  box-sizing: border-box;
  border: 2px solid transparent;
}
::ng-deep .autocomplete-results .company-row:hover {
  background: #E7ECF1;
  cursor: pointer;
}
::ng-deep .autocomplete-results .company-row:focus,
::ng-deep .autocomplete-results .company-row:active {
  border: 2px solid #00529C;
  background: #E7ECF1;
}
::ng-deep .autocomplete-results .company-row .deals,
::ng-deep .autocomplete-results .company-row .contacts {
  max-width: 90px;
  display: flex;
  align-items: center;
}
::ng-deep .autocomplete-results .company-row .deals_flex-wrapper,
::ng-deep .autocomplete-results .company-row .contacts_flex-wrapper {
  border-radius: 16px;
  background: #D0D7DE;
  flex-grow: 1;
  max-width: 60px;
  justify-content: center;
  box-sizing: border-box;
}
::ng-deep .autocomplete-results .company-row .deals mat-icon,
::ng-deep .autocomplete-results .company-row .contacts mat-icon {
  font-size: 14px;
}
::ng-deep .autocomplete-results .name {
  display: flex;
  align-items: center;
}
::ng-deep .autocomplete-results .name_flex-wrapper {
  display: flex;
  flex-flow: column;
}
::ng-deep .autocomplete-results .website {
  align-items: end;
}
::ng-deep .autocomplete-results .website a {
  text-decoration: none;
  color: #000;
  opacity: 0.6;
  font-size: 12px;
  cursor: pointer;
}
::ng-deep .autocomplete-results .website a:hover {
  text-decoration: underline;
}
::ng-deep .autocomplete-results .deals,
::ng-deep .autocomplete-results .contacts {
  box-sizing: border-box;
  align-items: center;
  font-size: 14px;
}
::ng-deep .autocomplete-results .deals_flex-wrapper,
::ng-deep .autocomplete-results .contacts_flex-wrapper {
  display: flex;
  align-items: center;
  padding: 4px 10px;
}
/*# sourceMappingURL=add-new-company-autocomplete.component.css.map */
